/**
 * Westmoreland Theme Configuration
 *
 * Default/Generic theme with blue color palette.
 * Uses GenericHeader and GenericHero components.
 */

export const westmorelandTheme = {
  name: 'westmoreland',
  brandName: 'Westmoreland County Community College',
  logoPath: 'westmoreland_logo.png',
  colors: {
    headerColor: '#7EB3D7',
    headerHover: '#5a9bc7',
    frameColor: '#79bce1',
    buttonColor: '#0c85b6',
    buttonHover: '#0a6b94',
    highlightButtonColor: '#992222',
    highlightButtonHover: '#7a1b1b',
    headerButtonColor: '#992222',
    textColor: '#0E2049',
    lightTextColor: '#FFFFFF',
    buttonTextColor: '#FFFFFF',
    headerTextColor: '#FFFFFF',
    headerButtonTextColor: '#699864',
    alertColor: '#E32323',
    alertHover: '#c21e1e',
    successColor: '#699864',
    successHover: '#527a4d',
    inactiveColor: '#C3C3C3',
    // Gradient colors for primaryGlow buttons
    primaryGradientFrom: '#0c85b6',
    primaryGradientTo: '#0a6b94',
    accentGradientFrom: '#992222',
    accentGradientTo: '#7a1b1b',
    successGradientFrom: '#699864',
    successGradientTo: '#527a4e'
  },
  components: {
    header: 'GenericHeader',
    hero: 'GenericHero',
    footer: 'GenericFooter'
  },
  features: {
    megaMenu: false,
    searchBar: false,
    scrollEffects: false,
    heroSection: false
  },
  contact: {
    email: 'info@westmoreland.edu',
    phone: '(123) 456-7890',
    address: '123 Main St, City, ST 12345'
  },
  branding: {
    tagline: '',
    heroTitle: 'Welcome to the Campus Store',
    heroDescription: 'Shop for all your campus needs',
    heroImage: '/hero-background.jpg'
  }
}
